/** Display labels for tab-time units, named periods, shared by the Tab Time
 *  Controls popover and the researcher editor's alignment callout. */
export const TREND_UNIT_LABELS: Record<string, string> = {
  week: "Week",
  month: "Month",
  quarter: "Quarter",
  semester: "Semester",
};

export const PIT_PERIOD_LABELS: Record<string, string> = {
  latest_quarter: "Latest Quarter",
  previous_quarter: "Previous Quarter",
  latest_semester: "Latest Semester",
  previous_semester: "Previous Semester",
  all_time: "All Time",
  custom_period: "Custom Period",
};
